import React, { useEffect } from 'react'
import { Box, Flex } from 'rebass'
import styled, { createGlobalStyle } from 'styled-components'

const CookieListStyle = createGlobalStyle`
  #ot-sdk-cookie-policy {
    & > * {
      font-family: ${(props) => props.theme.font} !important;
    }

    h1, h2, h3, h4, h5, h6 {
      color: ${(props) => props.theme.colors.blue} !important;
      text-transform: uppercase;
      margin-bottom: 2.2rem !important;
    }

    h3, h4, h5, h6 {
      margin-bottom: 1rem !important;
    }

    p, #cookie-policy-description {
      font-size: 1rem !important;
      line-height: 2.2rem !important;
      margin-bottom: 2.2rem !important;
    }
  }
`

const FlexWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  max-width: ${(props) => props.theme.content.max.width};
  margin-left: auto;
  margin-right: auto;
`

const CookieListWidget = () => {
  useEffect(() => {
    if (window.OneTrust) {
      window.OneTrust.initializeCookiePolicyHtml()
    }
  }, [])

  return (
    <FlexWrapper className="cookie-list" mt={35}>
      <Box width="100%" mx={[2, 2]}>
        <CookieListStyle />
        <div id="ot-sdk-cookie-policy"></div>
      </Box>
    </FlexWrapper>
  )
}

export default CookieListWidget
